export class Station {
    constructor(public name: string, 
                public positionX: string, 
                public positionY: string, 
                public difficult: number, 
                public color: string[], 
                public center: boolean,
                public didYouKnow: string,
                public rotate: number) { }
}